export const sizes = {
  inputHeight:   '36px',
  buttonHeight:  '34px',
  buttonSm:      '26px',
  avatarSm:      '24px',
  avatarMd:      '32px',
  avatarLg:      '40px',
  headerHeight:  '50px',
  sidebarWidth:  '220px',
  sidebarCollapsed: '64px',
} as const;
